import { Parallax } from "../lib/Parallax.mjs";
Parallax.parseWordActivate();
Parallax.init(document, {resize: false});

import { MainLogo } from "../lib/MainLogo.mjs";
window.mainLogo = new MainLogo(
  document.getElementById('logo'),
  document.querySelectorAll('.container-left-expand'),
  document.querySelectorAll('.screen-dark')
);

import {ScreenContrast} from "../lib/ScreenContrast.mjs";
window.screenContrast = new ScreenContrast(document.querySelectorAll('.screen.bg-black,.screen.bg-dark,.screen.bg-primary,.screen-dark'));

const panels = document.querySelectorAll('.panel');
panels.forEach(panel =>{
  panel.querySelectorAll('.btn-close').forEach(el => {
    el.addEventListener('click', ()=>{
      panel.classList.remove('active');
      document.body.classList.remove('modal-open');
    })
  })

  panel.querySelectorAll('.dimmer').forEach(el => {
    el.addEventListener('click', ()=>{
      panel.classList.remove('active');
      document.body.classList.remove('modal-open');
    })
  })
})

const wechatPanel = document.getElementById('panel-wechat');
document.querySelectorAll('.social-media .wechat').forEach(el =>{
  el.addEventListener('click', evt=>{
    evt.preventDefault();
    wechatPanel.classList.add('active');
    return false;
  })
})

const urlParams = new URLSearchParams(window.location.search);
if(urlParams.get('share') === 'wechat'){
  document.getElementById('panel-wechat').classList.add('active');
}